import { registerLocaleData } from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeZh from '@angular/common/locales/zh';
import localeZhTW from '@angular/common/locales/zh-Hant';
import localeFr from '@angular/common/locales/fr';
import localeJp from '@angular/common/locales/ja';
import localeDe from '@angular/common/locales/de';
import localeKo from '@angular/common/locales/ko';
import localeAr from '@angular/common/locales/ar';
import localeEs from '@angular/common/locales/es';
import localeRu from '@angular/common/locales/ru';

const localeMap: Record<string, any> = {
  en: localeEn,
  it: localeIt,
  zh: localeZh,
  'zh-TW': localeZhTW,
  fr: localeFr,
  jp: localeJp,
  de: localeDe,
  ko: localeKo,
  ar: localeAr,
  es: localeEs,
  ru: localeRu
};

export function registerLocales(languageCodes: string[]) {
  for (const code of languageCodes) {
    const locale = localeMap[code];
    if (locale) {
      try {
        registerLocaleData(locale, code);
      } catch (e) {
        console.warn(`Locale already registered or error registering locale: ${code}`, e);
      }
    } else {
      console.warn(`Locale data not available for code: ${code}`);
    }
  }
}
